import { createEntityAdapter } from '@reduxjs/toolkit';
const getTransactionId = (transaction) => `${transaction.chainId}_${transaction.hash}`;
export const transactionsAdapter = createEntityAdapter({
    selectId: (transaction) => getTransactionId(transaction),
    sortComparer: (a, b) => getTransactionId(a).localeCompare(getTransactionId(b)),
});
export const transactionSelectors = transactionsAdapter.getSelectors();
//# sourceMappingURL=trackedTransaction.js.map